(function(){
    'use strict';

    angular
    .module('appback')
    .controller('PublicacionfotoContoller', PublicacionfotoContoller)
 
    PublicacionfotoContoller.$inject = ["socket","FotopublicacionService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce","Upload"];
              
    function PublicacionfotoContoller(socket,FotopublicacionService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce,Upload)
    {                         
        var vm = this;
        vm.user_id = false;
        vm.generalLab = GenerallabService;
        vm.publicaciones = [];
        vm.categorias = [];
        vm.open = false;

        

        vm.init = function(username){
            vm.user_id = username;
            socket.emit('pizarra:join', {room:'pizarra',username:username});
        	FotopublicacionService.getPublicaciones(function(data){
                vm.publicaciones = data.publicaciones;
                vm.categorias = data.categorias;
                
        	})
	    }

      vm.addFotoSeleccionada = function(file){
         vm.open = true;
          vm.fotoSeleccionada = file;
          vm.fotoSeleccionada.url = '/backend/uploads/fotopublicacion/'+file.file_name;
      }


    
        vm.addPublicacion = function(item){
            
             vm.cartaModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'addpublicacion.html',
                  size: 'md',
                  backdrop:'static',
                  controller: function($scope) {
                    $scope.newCard = {};
                    if(angular.isDefined(item)){
                      $scope.newCard = item;
                    }
                    $scope.item = item;
                    $scope.okForm = function(){
                        console.log("newCard",$scope.newCard);
                        FotopublicacionService.nuevaPublicacion($scope.newCard,function(data){
                          if(angular.isUndefined(item)){
                          	vm.publicaciones.push(data.publicacion);
                          }
                          vm.cartaModal.close();
                        });
                    }

                    $scope.koForm = function(){
                        vm.cartaModal.close();
                    }
                   
                  }
              });
        }
    }
  
})();